import { NumericFormat } from "react-number-format";
import { makeStyles } from "tss-react/mui";
import { MiInputTextbox } from "@miplatform/components";

export function QuantityField({
  quantity,
  disabled,
  onChange = () => {},
}: Readonly<QuantityFieldProps>) {
  const { classes } = useStyles();

  return (
    <NumericFormat
      customInput={MiInputTextbox}
      disabled={disabled}
      value={quantity}
      allowNegative={false}
      decimalScale={0}
      className={classes.inputQuantity}
      onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
        if (!Number(e.target.value)) {
          onChange(1);
        }
      }}
      onValueChange={({ floatValue }) => {
        onChange(floatValue || 0);
      }}
    />
  );
}

const useStyles = makeStyles()((theme) => ({
  inputQuantity: {
    width: 35,
    backgroundColor: theme.palette.common.white,
    zIndex: 1,
    "& .MuiInputBase-input.MuiOutlinedInput-input": {
      textAlign: "center",
      padding: 0,
    },
  },
}));

interface QuantityFieldProps {
  quantity?: number;
  disabled?: boolean;
  onChange?: (quantity: number) => void;
}
